import { cn, Icon } from "@qw/ui";
import type { CSSProperties } from "react";
import { useInsuredFiles } from "../../hooks";
import type { TreeNode } from "../../util";

export const TagTreeNode = ({ tag, depth }: { tag: TreeNode; depth: number }) => {
  const { selectedTags, setSelectedTags, setFoldersVisible } = useInsuredFiles();

  const tagLabel = tag.data.label;
  const selected = selectedTags === tagLabel;

  return (
    <div className={cn("text-xs", depth === 0 ? "font-semibold py-1.5" : "font-normal")}>
      <div
        style={{ "--depth": depth } as CSSProperties}
        className={cn(
          "cursor-pointer flex gap-3 items-center py-1.5 pl-[calc((var(--depth))*1.5rem)]",
          selected ? "filled" : "text-muted-foreground"
        )}
        onClick={() => {
          setFoldersVisible(false);
          setSelectedTags((curr) => (curr === tagLabel ? "" : tagLabel));
        }}
      >
        <Icon icon={selected ? "folder_open" : "folder"} />
        <span className={cn("truncate")}>{tag.data.label}</span>
      </div>
      {tag.children.map((child) => (
        <TagTreeNode key={child.data.label} tag={child} depth={depth + 1} />
      ))}
    </div>
  );
};
